import { Center, HStack, Heading, Spinner, VStack } from "native-base";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import moment from "moment";
import qs from "qs";
import colors from "../../../constants/colors";
import Itinerary from "../../../components/itinerary";
import API from "../../../api";
import { StateContext, StatusContext } from "../../../contexts";
import QuotationFinishedModal from "../../../components/quotationFinishedModal";
import TourCard from "../../../components/tourCard";

function ExperienceCreationComplementsPage() {
  const params = useParams();
  const state = useContext(StateContext);
  const status = useContext(StatusContext);
  const [isLoading, setIsLoading] = useState(true);
  const [finished, setFinished] = useState(false);
  const [itinerary, setItinerary] = useState([]);
  const [tours, setTours] = useState([]);

  const getQuotation = useCallback(async () => {
    try {
      setIsLoading(true);
      const {
        data: {
          data: { itinerary: _itinerary },
        },
      } = await API(state.jwt).get(`/quotations/${params.id}`);
      setItinerary(_itinerary);
      const _destination = _itinerary.find(
        (location) => !location.isReturn && location.type === "destination",
      );
      const query = qs.stringify({
        filters: {
          isPublic: true,
          status: true,
          id: { $ne: params.id },
          itinerary: {
            type: "origin",
            isReturn: false,
            departureDate: {
              $gte: moment().toISOString(),
            },
            city: _destination.city,
          },
          card4b: { $notNull: true },
        },
      });
      const {
        data: { data: _tours },
      } = await API().get(`/tours?${query}`);
      setTours(_tours);
    } catch (error) {
      if (error?.response?.data?.error?.details?.finished) {
        setFinished(true);
      }
      status.updateErrorMessage(error);
    }
    setIsLoading(false);
  }, [state.jwt, params.id, status]);

  useEffect(() => {
    getQuotation();
  }, [getQuotation]);

  const destination = itinerary.find(
    (location) => !location.isReturn && location.type === "destination",
  );

  return (
    <VStack paddingX={5}>
      <Helmet>
        <title>Selección de vehículo</title>
      </Helmet>
      <HStack space={3} alignItems="flex-start">
        <VStack flex={1} space={5} maxWidth={300} width="full">
          <Heading color={colors.secondary} fontSize="2xl">
            Resumen de compra
          </Heading>
          <VStack backgroundColor={colors.white} padding={5}>
            {isLoading ? (
              <Center height={300}>
                <Spinner size="lg" color={colors.primary} />
              </Center>
            ) : (
              <Itinerary itinerary={itinerary} />
            )}
          </VStack>
        </VStack>
        {isLoading ? (
          <Center height={300} flex={1}>
            <Spinner size="lg" color={colors.primary} />
          </Center>
        ) : (
          <VStack flex={1} space={5}>
            <Heading color={colors.secondary} fontSize="2xl">
              ¿No sabes que hacer en {destination.city}?
            </Heading>
            <HStack flexWrap="wrap">
              {tours.map((tour) => (
                <TourCard key={tour.id} tour={tour} quotation={params.id} />
              ))}
            </HStack>
          </VStack>
        )}
      </HStack>
      <QuotationFinishedModal isOpen={finished} role="user" />
    </VStack>
  );
}

export default ExperienceCreationComplementsPage;
